import { SafeResourceUrl } from '@angular/platform-browser';
import { createAction, props } from '@ngrx/store';

export enum ConsultPatientLabels {
  SET_TURN_TYPE = 'COMMON_CONSULT_PATIENT_SET_TURN_TYPE',
  SET_HISTORY_PDF = 'COMMON_CONSULT_PATIENT_SET_HISTORY_PDF',
  SET_ALL_DEFAULT = 'COMMON_CONSULT_PATIENT_SET_ALL_DEFAULT'
}

export const consultPatientActions = {
  setTurnTypeAction: createAction(ConsultPatientLabels.SET_TURN_TYPE, props<{ turnType: 'GENERAL' | 'ODONTOLOGY' }>()),
  setHistoryPdfAction: createAction(ConsultPatientLabels.SET_HISTORY_PDF, props<{ file: SafeResourceUrl }>()),
  setAllDefaultAction: createAction(ConsultPatientLabels.SET_ALL_DEFAULT, props<any>())
};
